import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import './CustomerServicePage.css';
import customerServiceAvatar from '../image/绘制客服悬浮球.png';

const CustomerServicePage = () => {
  const navigate = useNavigate();
  const [showFaqModal, setShowFaqModal] = useState(false);
  const [selectedFaqKey, setSelectedFaqKey] = useState(null);

  // 统一客服电话常量与拨号函数（移动端使用 tel: 协议唤起拨号盘）
  const PHONE = '02860786646';
  const handleDial = () => {
    try {
      window.location.href = `tel:${PHONE}`;
    } catch (e) {
      // 兼容性降级：若浏览器不支持tel协议，保持静默或可提示
    }
  };

  // 常见问题数据
  const FAQS = [
    {
      key: 'refund',
      title: 'FAQ-退款常见问题',
      content: `Q1:申请退款后，多久时间内到账
退款棲騳删处俶理駐呖菏时间预计为7个工作日，具体到账时间受各支付渠道退款处理周期影响，请留意支付账号的返还通知。
Q2:什么情况下会退款不成功
若您是通过第三方平台购买、或是通过对公转账支付，或支付时间超一年以上，直接申请退款会导致款项无法原路返还。如遇此情况管家或在线客服会主动联系您进行沟通，请留意接听95开头的来电号码。
Q3:为什么退款状态是成功，但我没有收到钱?
正常情况下退款金额是原路返还，若您是先充值后购买，退款金额会自动退回到原账户中。若您需要对充值金额发起退款，可联系在线客服为您处理，预计7个工作日退回。
Q4鎳涌:如果我有使用第三方支付平台(如云闪付、龙支付等)的优惠，退款的时候会退回这部分优惠吗?
退款金额只针对您的实际支付金额，第三方支付平台的优惠是否能够退回以第三方支付平台规则为主。
05:申请退款，赠送的服务如何退回
如赠送的单次服务没有使用，则取消赠送的服务单。如赠送的单次服务已使用，则按商城对应价格进行折算。退款金额=销售订单支付金额-赠品商城价。
06:申请退款，已使用部分服务，退款如何计算
扣除已使用服务次数的对应金额，已使用的服务次数按对应城市的单次商城价格进行结算。退款金额=套餐支付总金额-已使用次数*当地城市单次商城价格-赠品折算价格。
Q7:实体赠品已使用部分，退款如何计算
根据赠品使用状况，进行部分扣除或全部费用的处理，费用以商城价为准。`
    },
    {
      key: 'scope',
      title: '超出服务范围常见问题',
      content: `Q1:空调类无法拆洗类别
空调外机暂时不在服务范围，暂不提供空调加雪种、加氟服务。8年以上的老旧空调因老化严重、易刮花，外壳易破碎等不可服务。空调损坏，有异响、故障、抖动、出风不畅、不能正常运转等无法拆洗。中央空调出风口长度超过6米不可服务，为确保服务人员安全，所有空调机型高度超出3米不可服务。圆形柜机、嵌入墙内的挂机，天花机等不可拆洗。
02:包年类订单擦窗服务限制
1.双面基础擦窗包含使用双面玻璃擦进行玻璃面清洁。不包含窗框、窗槽清洁，纱窗、百叶窗、防护窗、胶渍玻璃等均不在服务范围之内。高于3米，厚度大于28mm的整扇窗不在服务范围内;如遇镀膜玻璃、贴膜玻璃、磨砂玻璃、破损玻璃、双层玻璃、中空玻璃等无法使用双面玻璃擦清洁，保洁师将用保洁布清洁内部单面玻璃:
03:双面精细擦窗服务限制
仅服务于日常居家环境。学校、办公室、商铺租房新入住、退房打扫、新房开荒、群租房、1个月以上未入住房、宿舍楼、自建房等均不在服务范围之内;整扇窗高于3米不提供服务;恶劣天气(大雾大雪大雨等特殊天气)情况下，为保障服务人员安全，不可服务;防护栏与玻璃间隙无法容纳玻璃擦，砂玻璃曲面玻璃、镀膜玻璃、损坏玻璃不可服务;室外温度低于0°C(玻璃结冰结霜)的情况下，只清洁内窗;密封玻璃暂时只清洁内窗，玻璃厚度超过45毫米只服务内窗;陈年水垢无法去除，不提供服务。`
    },
    {
      key: 'invoice',
      title: '开票常见问题',
      content: `Q1:开发票须知
保洁单次、保姆单次、企业保洁单次、家务小时工单次、深度保洁、奢侈品养护、家电清洗、软装包养、开荒保洁、大扫除、除蟑除螨、专业消杀订单需使用完成后可申请开票。保洁初体验、保姆初体验、好厨娘初体验、半天保姆初体验、企业保洁初体验、家务小时工初体验订单需完成1次服务后可申请开票。
保洁包年、企业保洁包年、家务小时工包年、星保姆包年、好厨娘包年、半天保姆包月、科学月子、高端育婴、家居养护包年、康美家充值余额购买订单后可申请开票。

02:开具发票需准备哪些资料
可开具增值税普通发票，开具个人发票请提供①开票人姓名、②身份证号(选填)、③提供接收发票的电子邮箱;开具企业发票麻烦提供①纳税识别号、②公司名称、③接收电子发票的邮箱、(4)开户行及账号(选填)、⑤公司电话(选填)。发票开具后直接发送到您的电子邮箱。`
    },
    {
      key: 'coupon',
      title: '优惠券常见问题',
      content: `Q1:第三方赠送优惠券如何兑换
若您是通过第三方平台赠送或购买的优惠券，请点击个人中心我的-优惠券-兑换券码-输入赠送券码，系统将生成相应优惠券
Q2:优惠券如何使用
对应优惠券对应相应产品，优惠券不可跨品类使用，点击分类点击需兑换的相应产品-点击立即购买-选择相应优惠券-支付订单即可兑换成功
03:优惠券过期怎么办
若您是购买包年订单赠送的优惠券或购买的优惠券未在有效期内及时兑换，您可以联系在线客服申请优惠券延期使用，若您是通过第三方平台赠送优惠券，请您在有效期内完成兑换，超时将失效作废，无法延长使用时间`
    }
  ];

  const openFaq = () => { setSelectedFaqKey(null); setShowFaqModal(true); };
  const closeFaq = () => setShowFaqModal(false);
  const selectFaq = (key) => setSelectedFaqKey(key);

  const renderFaqContent = (text) => {
    const lines = String(text).split('\n');
    return lines.map((line, idx) => {
      const t = line.trim();
      if (!t) return <p key={idx} className="faq-p empty-line">&nbsp;</p>;
      if (/^Q\d+[:：]/.test(t)) return <p key={idx} className="faq-q">{t}</p>;
      if (/^\d{2}[:：]/.test(t)) return <p key={idx} className="faq-sub">{t}</p>;
      return <p key={idx} className="faq-p">{t}</p>;
    });
  };


  const handleBack = () => {
    navigate(-1);
  };

  return (
    <div className="customer-service-page">
      {/* 页面头部 */}
      <header className="service-header">
        <button className="back-btn" onClick={handleBack} aria-label="返回">
          ←
        </button>
        <h1>客服中心</h1>
        <div className="header-placeholder"></div>
      </header>

      {/* 客服对话区域 */}
      <div className="chat-container">
        <div className="chat-content">
          {/* 客服消息 */}
          <div className="message-item service-message">
            <div className="avatar-container">
              <img
                src={customerServiceAvatar}
                alt="客服头像"
                className="service-avatar"
              />
            </div>
            <div className="message-bubble">

        {/* FAQ 模态框 */}
        {showFaqModal && (
          <div className="modal-overlay" onClick={closeFaq}>
            <div className="modal-content user-agreement-modal faq-modal" onClick={(e) => e.stopPropagation()}>
              <div className="modal-header">
                <h2>常见问题</h2>
                <button className="modal-close" onClick={closeFaq} aria-label="关闭">×</button>
              </div>
              <div className="modal-body">
                {!selectedFaqKey ? (
                  <div className="user-agreement-content">
                    {FAQS.map(f => (
                      <button key={f.key} className="action-btn" onClick={() => selectFaq(f.key)} style={{ width: '100%', marginBottom: 12 }}>
                        <span className="action-text" style={{ fontSize: '0.95rem' }}>{f.title}</span>
                      </button>
                    ))}
                  </div>
                ) : (
                  <div className="faq-content-wrap">
                    <div className="user-agreement-content faq-content">
                      {renderFaqContent(FAQS.find(f => f.key === selectedFaqKey)?.content || '')}
                    </div>
                    <div className="faq-hint">可上下滑动阅读</div>
                  </div>
                )}
              </div>
              <div className="modal-footer">
                {!!selectedFaqKey ? (
                  <button className="btn modal-btn" onClick={() => setSelectedFaqKey(null)}>返回列表</button>
                ) : (
                  <button className="btn modal-btn" onClick={closeFaq}>关闭</button>
                )}
              </div>
            </div>
          </div>
        )}

              <div className="message-text">
                益美科技家政服务 有任何疑问请与我联系，或者对家政人员有什么投诉建议，也可以与我联系哦^_^
              </div>
              <div className="message-time">
                {new Date().toLocaleTimeString('zh-CN', {
                  hour: '2-digit',
                  minute: '2-digit'
                })}
              </div>
            </div>
          </div>

          {/* 系统提示消息 */}
          <div className="system-message">
            <div className="system-text">
              欢迎使用客服服务，我们将竭诚为您服务
            </div>
          </div>
        </div>

        {/* 快捷操作按钮 */}
        <div className="quick-actions">
          <div className="action-title">常见问题</div>
          <div className="action-buttons">
            <button className="action-btn" onClick={handleDial}>
              <span className="action-icon">📞</span>
              <span className="action-text">电话咨询</span>
            </button>
            <button className="action-btn" onClick={handleDial}>
              <span className="action-icon">💬</span>
              <span className="action-text">在线客服</span>
            </button>
            <button className="action-btn" onClick={handleDial}>
              <span className="action-icon">📋</span>
              <span className="action-text">服务投诉</span>
            </button>
            <button className="action-btn" onClick={openFaq}>
              <span className="action-icon">❓</span>
              <span className="action-text">常见问题</span>
            </button>
          </div>
        </div>

        {/* 联系方式 */}
        <div className="contact-info">
          <div className="contact-title">联系方式</div>
          <div className="contact-items">
            <div className="contact-item">
              <span className="contact-label">客服热线：</span>
              <a className="contact-value" href={`tel:${PHONE}`}>{PHONE}</a>
            </div>
            <div className="contact-item">
              <span className="contact-label">服务时间：</span>
              <span className="contact-value">9:00-21:00</span>
            </div>
            <div className="contact-item">
              <span className="contact-label">微信客服：</span>
              <span className="contact-value">大狸</span>
            </div>
          </div>
        </div>
      </div>

      {/* 底部输入区域（预留） */}
      <div className="chat-input-area">
        <div className="input-placeholder">
          客服功能正在完善中，如需帮助请拨打客服热线
        </div>
      </div>
    </div>
  );
};

export default CustomerServicePage;

